import { render, staticRenderFns } from "./OppotunityDetail-AllQuotations.vue?vue&type=template&id=1575b94a"
import script from "./OppotunityDetail-AllQuotations.vue?vue&type=script&lang=js"
export * from "./OppotunityDetail-AllQuotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports